module.exports = __webpack_public_path__ + "static/media/fireb.5ce195d9.jpg";